export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ21.605e6f6c.mp3";